import React, { FC } from 'react';
import { Routes, Route } from 'react-router-dom';

import UserForm from '../user-form';
import UserVehicles from '../user-vehicles';
import UserLinks from '../user-links';

const UserContent: FC = () => {
  return (
    <div className="grid__col grid__col_12 grid__col_lg_9">
      <Routes>
        <Route path="/" element={<UserLinks />} />
        <Route path="/vehicles" element={<UserVehicles />} />
        <Route path="/account" element={<UserForm />} />
      </Routes>
    </div>
  );
};

export default UserContent;
